import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable()
export class SharedService {

    //todo:- comment this before checkin
    // baseURL = 'http://isponline.det.nsw.edu.au/api';

    //todo:- uncomment this before checkin
    baseURL = '/api';
   
    //baseURL = '/api';
   

    headerText = 'NSW Government Schools - Online Application Portal';

    private dashboardOptions: any = {
        pageSize: 10,
        pageNum: 0,
        searchTerm: '',
        sortColumn: 'StudentNumber',
        sortDirection: 'asc'
    };

    getBaseURL(): string {
        return this.baseURL;
    }

    setHeaderText(text: string) {
        if (text) {
            this.headerText = text;
        }
    }

    resetHeaderText() {
        this.headerText = 'NSW Government Schools - Online Application Portal';
    }

    getHeaderText() {
        return this.headerText || 'NSW Government Schools - Online Application Portal';
    }

    setDashboardOptions(options: any) {
        if (!options) {
            return;
        }

        if (options.pageSize) {
            this.dashboardOptions.pageSize = options.pageSize;
        }

        if (!isNaN(options.pageNum)) {
            this.dashboardOptions.pageNum = options.pageNum;
        }

        if (options.searchTerm || options.searchTerm === '') {
            this.dashboardOptions.searchTerm = options.searchTerm;
        }

        if (options.sortColumn) {
            this.dashboardOptions.sortColumn = options.sortColumn;
        }

        if (options.sortDirection === 'asc' || options.sortDirection === 'desc') {
            this.dashboardOptions.sortDirection = options.sortDirection;
        }
    }

    set dashboardPageSize(value: number) {
        if (this.dashboardOptions.pageSize > 0) {
            this.dashboardOptions.pageSize = value;
        }
    }

    set dashboardPageNum(value: number) {
        if (value >= 0) {
            this.dashboardOptions.pageNum = value;
        }
    }

    set dashboardSearchTerm(value: string) {
        this.dashboardOptions.searchTerm = value;
    }

    set dashboardSortColumn(value: string) {
        this.dashboardOptions.sortColumn = value
    }

    set dashboardsortDirection(value: boolean) {
        this.dashboardOptions.sortDirection = value;
    }

    get dashboardPageSize() {
        return this.dashboardOptions.pageSize;
    }

    get dashboardPageNum() {
        return this.dashboardOptions.pageNum;
    }

    get dashboardSearchTerm() {
        return this.dashboardOptions.searchTerm;
    }

    get dashboardSortColumn() {
        return this.dashboardOptions.sortColumn;
    }

    get dashboardsortDirection() {
        return this.dashboardOptions.sortDirection;
    }
}
